export const TRACK_EVENT = "shared/Tracking/TRACK_EVENT";
export const PUSH_TO_DIGITAL_LAYER = "shared/Tracking/PUSH_TO_DIGITAL_LAYER";
export const INITIALIZE_DIGITAL_LAYER =
  "shared/Tracking/INITIALIZE_DIGITAL_LAYER";
